exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._34qFjgm7h7te3o_GEgF9lP{clear:both;margin-bottom:150px}._34qFjgm7h7te3o_GEgF9lP .ywanha2rCHcOPmKTlajbY{text-align:center;margin:0 0 35px 0}._34qFjgm7h7te3o_GEgF9lP ._35Wl9P2CJZeDjjyOhvb4gD{margin-top:50px}._34qFjgm7h7te3o_GEgF9lP ._1kcV1guy5vw61zsZp5Jy6A{margin-bottom:60px}._34qFjgm7h7te3o_GEgF9lP ._3nGmLWhgRz_Te2O8UsjdVb{margin-top:30vh}\n", ""]);

// Exports
exports.locals = {
	"UserGoalsPage": "_34qFjgm7h7te3o_GEgF9lP",
	"setGoalHeading": "ywanha2rCHcOPmKTlajbY",
	"yourGoals": "_35Wl9P2CJZeDjjyOhvb4gD",
	"goalsList": "_1kcV1guy5vw61zsZp5Jy6A",
	"loadingSpinner": "_3nGmLWhgRz_Te2O8UsjdVb"
};